<template>
  <div class="padding-sm wrapper">
    <div class="right-header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
        <el-breadcrumb-item v-for="(item,index) in navStr"
                            :key="item.id"
                            :to="index === 0?'/home/contract?id='+item.id+'&name=合同管理&system=4':'/home/contractList?id='+navStr[0].id + '&cid='+item.id + '&name='+item.name+'&system=4'">
          {{ item.name }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          合同信息编辑
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <span class="goBtn" @click="prev">返回</span>
      </div>
    </div>

    <div class="flex align-start justify-between froms">
      <div class="flex-sub margin-right-sm">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <h3 class="mode-title">合同基本信息</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="合同名称" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入合同名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同编号" prop="number">
                <el-input v-model="ruleForm.number" placeholder="请输入合同编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同类型" prop="type">
                <el-select v-model="ruleForm.type" placeholder="请选择合同类型">
                  <el-option
                    v-for="item in contractType" :key="item.value"
                    :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同密级" prop="leave">
                <el-select v-model="ruleForm.leave" placeholder="请选择合同密级">
                  <el-option
                    v-for="item in contractLevel" :key="item.value"
                    :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生效日期" prop="startTime">
                <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.startTime"
                                style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终止日期" prop="endTime">
                <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.endTime"
                                style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同金额" prop="money">
                <el-input type="number" v-model="ruleForm.money" placeholder="请输入合同金额"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="大写" prop="moneyCN">
                <el-input v-model="ruleForm.moneyCN" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="合同情况说明" prop="explain">
                <el-input type="textarea" v-model="ruleForm.explain" placeholder="请输入合同情况说明"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="flex align-center justify-between">
            <h3 class="mode-title">合同付款约定</h3>
            <el-button type="primary" @click="ydListState = true">添加</el-button>
          </div>
          <el-table
            :data="ruleForm.paymentContract"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            border
            style="width: 100%">
            <el-table-column
              align="center"
              type="index"
              width="50">
            </el-table-column>
            <el-table-column prop="payment_type" label="款项阶段">
              <template slot-scope="scope">
                {{ scope.row.payment_type|payment_type }}
              </template>
            </el-table-column>
            <el-table-column prop="pay_time" label="付款日期"></el-table-column>
            <el-table-column prop="pay_company" label="付款单位"></el-table-column>
            <el-table-column prop="collect_company" label="收款单位"></el-table-column>
            <el-table-column prop="pay_condition" label="付款内容"></el-table-column>
            <el-table-column prop="pay_money" label="付款金额"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="flex align-center justify-around">
                  <el-button size="small" type="primary" icon="el-icon-edit" circle
                             @click="editItem(scope.row)"></el-button>
                  <el-popconfirm
                    hideIcon
                    title="确定删除当前记录吗？"
                    @confirm="delItem(scope.row.id)"
                  >
                    <el-button slot="reference" size="small" type="danger" icon="el-icon-delete" circle></el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <h3 class="mode-title">签署执行状态</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="签署方数" prop="contractNum">
                <el-select v-model="ruleForm.contractNum" placeholder="请选择签署方数">
                  <el-option
                    v-for="item in signedNum" :key="item.value"
                    :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="甲方公司" prop="aorgName">
                <el-input v-model="ruleForm.aorgName" placeholder="请输入甲方公司"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="甲方公司地址" prop="aorgAddress">
                <el-input v-model="ruleForm.aorgAddress" placeholder="请输入甲方公司地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="aorgContacts">
                <el-input v-model="ruleForm.aorgContacts" placeholder="请输入联系人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="aorgPhone">
                <el-input v-model="ruleForm.aorgPhone" placeholder="请输入联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行" prop="aorgOpenBank">
                <el-input v-model="ruleForm.aorgOpenBank" placeholder="请输入开户行"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行账号" prop="aorgBankNum">
                <el-input v-model="ruleForm.aorgBankNum" placeholder="请输入开户行账号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="乙方公司" prop="borgName">
                <el-input v-model="ruleForm.borgName" placeholder="请输入甲方公司"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="乙方公司地址" prop="borgAddress">
                <el-input v-model="ruleForm.borgAddress" placeholder="请输入甲方公司地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="borgContacts">
                <el-input v-model="ruleForm.borgContacts" placeholder="请输入联系人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="borgPhone">
                <el-input v-model="ruleForm.borgPhone" placeholder="请输入联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行" prop="borgOpenBank">
                <el-input v-model="ruleForm.borgOpenBank" placeholder="请输入开户行"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行账号" prop="borgBankNum">
                <el-input v-model="ruleForm.borgBankNum" placeholder="请输入开户行账号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="第三方公司" prop="corgName">
                <el-input v-model="ruleForm.corgName" placeholder="请输入甲方公司"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="第三方公司地址" prop="corgAddress">
                <el-input v-model="ruleForm.corgAddress" placeholder="请输入甲方公司地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="corgContacts">
                <el-input v-model="ruleForm.corgContacts" placeholder="请输入联系人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式" prop="corgPhone">
                <el-input v-model="ruleForm.corgPhone" placeholder="请输入联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行" prop="corgOpenBank">
                <el-input v-model="ruleForm.corgOpenBank" placeholder="请输入开户行"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行账号" prop="corgBankNum">
                <el-input v-model="ruleForm.corgBankNum" placeholder="请输入开户行账号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="合同金额" prop="money">
                <el-input type="number" v-model="ruleForm.money" placeholder="请输入合同金额"
                          disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="币种" prop="currency">
                <el-select v-model="ruleForm.currency" placeholder="请选择币种" disabled>
                  <el-option
                    v-for="item in currencyType" :key="item.value"
                    :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="已支付金额" prop="payMoney">
                <el-input type="number" v-model="ruleForm.payMoney" placeholder="请输入已支付金额"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="锁定金额" prop="lockMoney">
                <el-input type="number" v-model="ruleForm.lockMoney" placeholder="请输入锁定金额"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="剩余金额" prop="surplusMoney">
                <el-input type="number" v-model="ruleForm.surplusMoney" placeholder="请输入剩余金额"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h3 class="mode-title">合同签署文件</h3>
          <el-collapse>
            <el-collapse-item>
              <template slot="title">
                <b class="font-size">合同范本 ({{ ruleForm.fanben.length }}项)</b>

              </template>
              <div v-for="(item,index) in ruleForm.fanben" :key="index"
                   class="flex align-center justify-between file-item">
                <div class="file-item-name">
                  <el-link :underline="false" type="primary" :href="item.file_path" target="_blank">
                    {{ item.file_name }}
                  </el-link>
                </div>

                <el-popconfirm
                  hideIcon
                  title="确定删除当前文件吗？"
                  @confirm="delFile('fanben', index)"
                >
                  <template #reference>
                    <i class="el-icon-delete close-icon"></i>
                  </template>
                </el-popconfirm>
              </div>
              <div class="flex align-center justify-center">
                <uploadFile
                  @syncFile="syncFile"
                  isAddItem
                  :keyText="'fanben'"
                ></uploadFile>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <b class="font-size">合同影像 ({{ ruleForm.yingxiang.length }}项)</b>

              </template>
              <div v-for="(item,index) in ruleForm.yingxiang" :key="index"
                   class="flex align-center justify-between file-item">
                <div class="file-item-name">
                  <el-link :underline="false" type="primary" :href="item.file_path" target="_blank">
                    {{ item.file_name }}
                  </el-link>
                </div>

                <el-popconfirm
                  hideIcon
                  title="确定删除当前文件吗？"
                  @confirm="delFile('yingxiang', index)"
                >
                  <template #reference>
                    <i class="el-icon-delete close-icon"></i>
                  </template>
                </el-popconfirm>
              </div>
              <div class="flex align-center justify-center">
                <uploadFile
                  @syncFile="syncFile"
                  isAddItem
                  :keyText="'yingxiang'"
                ></uploadFile>
              </div>
            </el-collapse-item>
            <el-collapse-item>
              <template slot="title">
                <b class="font-size">合同相关材料 ({{ ruleForm.xiangguanwenjian.length }}项)</b>

              </template>
              <div v-for="(item,index) in ruleForm.xiangguanwenjian" :key="index"
                   class="flex align-center justify-between file-item">
                <div class="file-item-name">
                  <el-link :underline="false" type="primary" :href="item.file_path" target="_blank">
                    {{ item.file_name }}
                  </el-link>
                </div>

                <el-popconfirm
                  hideIcon
                  title="确定删除当前文件吗？"
                  @confirm="delFile('xiangguanwenjian', index)"
                >
                  <template #reference>
                    <i class="el-icon-delete close-icon"></i>
                  </template>
                </el-popconfirm>
              </div>
              <div class="flex align-center justify-center">
                <uploadFile
                  @syncFile="syncFile"
                  isAddItem
                  :keyText="'xiangguanwenjian'"
                ></uploadFile>
              </div>
            </el-collapse-item>
          </el-collapse>
          <h3 class="mode-title">修改原因</h3>
          <el-form-item label="合同修改原因" prop="msg">
            <el-input type="textarea" v-model="ruleForm.msg" placeholder="请输入合同修改原因"></el-input>
          </el-form-item>
          <el-form-item label-width="0">
            <div class="flex align-center justify-center margin-top">
              <el-button type="primary" @click="submitForm('ruleForm')" style="width: 150px;">保存</el-button>
            </div>

          </el-form-item>
        </el-form>
      </div>
      <div class="other-box">

        <div class="padding-top-sm">
          <el-button type="danger" @click="delContract" style="width: 100%;">删除合同</el-button>
        </div>


        <h3 class="mode-title">合同修改记录</h3>


        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in logList"
            :key="index"
            :timestamp="activity.create_time">
            {{ activity.msg ? activity.msg : '修改合同信息' }}
          </el-timeline-item>
        </el-timeline>


      </div>
    </div>


    <ydList :ydListState="ydListState" :set-id="setId" :set-item="setItem" @getYdList="getYdList"/>

  </div>
</template>

<script>
import {
  contractLevel,
  contractType,
  currencyType,
  digitUppercase,
  filesCN,
  paymentType,
  signedNum,
  zhDate
} from "@/tools/utils";
import uploadFile from '../components/upFile'
import ydList from "@/views/components/ydList";

export default {
  name: "contractDetail",
  data() {
    return {
      navStr: [],
      contractType: contractType,
      contractLevel: contractLevel,
      signedNum: signedNum,
      currencyType: currencyType,
      attachment: [],
      ruleForm: {
        name: '',    //  * 合同名称
        number: '',    //  合同编号
        type: '',    //  合同类型
        leave: '',    //  秘密级别
        startTime: '',    //  合同生效日期；格式：YYYY-MM-DD
        endTime: '',    //  合同终止日期；格式：YYYY-MM-DD
        money: '',    //  合同金额 单位元，最多两位小数
        moneyCN: '',    //  合同金额大写 单位元，最多两位小数
        currency: '',    //  币种，默认：RMB
        explain: '',    //  合同情况说明

        paymentContract: [], // 支付约定（json）
        contractNum: '',    //签署方数量
        aorgName: '',    //  甲方公司名称
        aorgAddress: '',    //  甲方公司地址
        aorgContacts: '',    //  甲方联系人
        aorgPhone: '',    //  甲方联系人电话
        aorgOpenBank: '',    //  甲方开户行
        aorgBankNum: '',    //  甲方开户行账号
        borgName: '',    //  乙方公司名称
        borgAddress: '',    //  乙方公司地址
        borgContacts: '',    //  乙方联系人
        borgPhone: '',    //  乙方联系人电话
        borgOpenBank: '',    //  乙方开户行
        borgBankNum: '',    //  乙方开户行账号
        corgName: '',    //  丙方公司名称
        corgAddress: '',    //  丙方公司地址
        corgContacts: '',    //  丙方联系人
        corgPhone: '',    //  丙方联系人电话
        corgOpenBank: '',    //  丙方开户行
        corgBankNum: '',    //  丙方开户行账号

        payMoney: '',    //  已支付金额，单位元，最多两位小数
        lockMoney: '',    //  锁定金额，单位元，最多两位小数
        surplusMoney: '',    //  剩余金额，单位元，最多两位小数
        fanben: [],    //  合同范本（json）
        yingxiang: [],    //合同电子版（json）
        xiangguanwenjian: [],    //相关文件（json）
        msg: '',              //操作原因
      },
      rules: {
        name: [
          {required: true, message: '请输入合同名称', trigger: 'blur'},
        ],
        msg: [
          {required: true, message: '请输入合同修改原因', trigger: 'blur'},
        ],
      },
      ydListState: false,
      setId: 0,
      setItem: null,

      logList: []
    }
  },
  created() {
    this.NowTab()
    this.getDetail()
    this.contractLogList()

  },
  components: {uploadFile, ydList},
  methods: {
    // 删除合同
    delContract() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.apiContent
          .delContract({
            mid: this.$store.state.userMid,
            id: this.$route.query.htid,
            delMsg:'确认删除'
          }).then(res => {
          this.$message.success(res.msg)
          this.$router.go(-1)
        })
      })
    },
    //上传和删除后同步文件数据
    syncFile(data) {
      this.ruleForm[data.keyText] = [...this.ruleForm[data.keyText], ...data.attachment];
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.upInfo()
        }
      });
    },
    upInfo() {
      this.$api.apiContent
        .addOrUpdateContract({
          mid: this.$store.state.userMid,
          id: this.$route.query.htid,
          name: this.ruleForm.name,
          number: this.ruleForm.number,
          type: this.ruleForm.type,
          leave: this.ruleForm.leave,
          startTime: this.ruleForm.startTime ? zhDate(new Date(this.ruleForm.startTime)) : '',
          endTime: this.ruleForm.endTime ? zhDate(new Date(this.ruleForm.endTime)) : '',
          money: this.ruleForm.money,
          moneyCN: this.ruleForm.moneyCN,
          currency: this.ruleForm.currency,
          explain: this.ruleForm.explain,
          contractNum: this.ruleForm.contractNum,
          aorgName: this.ruleForm.aorgName,
          aorgAddress: this.ruleForm.aorgAddress,
          aorgContacts: this.ruleForm.aorgContacts,
          aorgPhone: this.ruleForm.aorgPhone,
          aorgOpenBank: this.ruleForm.aorgOpenBank,
          aorgBankNum: this.ruleForm.aorgBankNum,
          borgName: this.ruleForm.borgName,
          borgAddress: this.ruleForm.borgAddress,
          borgContacts: this.ruleForm.borgContacts,
          borgPhone: this.ruleForm.borgPhone,
          borgOpenBank: this.ruleForm.borgOpenBank,
          borgBankNum: this.ruleForm.borgBankNum,
          corgName: this.ruleForm.corgName,
          corgAddress: this.ruleForm.corgAddress,
          corgContacts: this.ruleForm.corgContacts,
          corgPhone: this.ruleForm.corgPhone,
          corgOpenBank: this.ruleForm.corgOpenBank,
          corgBankNum: this.ruleForm.corgBankNum,
          payMoney: this.ruleForm.payMoney,
          lockMoney: this.ruleForm.lockMoney,
          surplusMoney: this.ruleForm.surplusMoney,
          fanben: JSON.stringify(this.ruleForm.fanben),
          yingxiang: JSON.stringify(this.ruleForm.yingxiang),
          xiangguanwenjian: JSON.stringify(this.ruleForm.xiangguanwenjian),
          msg: this.ruleForm.msg,
        })
        .then(res => {
          this.$message.success(res.msg)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //  获取合同详情
    async getDetail() {
      await this.$api.apiContent
        .showContract({
          mid: this.$store.state.userMid,
          id: this.$route.query.htid
        }).then(res => {
          this.ruleForm = {
            name: res.data.name,
            number: res.data.number,
            type: res.data.type ? Number(res.data.type) : '',
            leave: res.data.leave ? Number(res.data.leave) : '',
            startTime: res.data.start_time?new Date(res.data.start_time):'',
            endTime: res.data.end_time?new Date(res.data.end_time):'',
            money: res.data.money ? Number(res.data.money) : '',
            currency: res.data.currency,
            explain: res.data.explain,
            paymentContract: res.data.payment_contract,
            contractNum: res.data.contract_num && Number(res.data.contract_num)!==0? Number(res.data.contract_num):'',
            aorgName: res.data.aorg_name,
            aorgAddress: res.data.aorg_address,
            aorgContacts: res.data.aorg_contacts,
            aorgPhone: res.data.aorg_phone,
            aorgOpenBank: res.data.aorg_open_bank,
            aorgBankNum: res.data.aorg_bank_num,
            borgName: res.data.borg_name,
            borgAddress: res.data.borg_address,
            borgContacts: res.data.borg_contacts,
            borgPhone: res.data.borg_phone,
            borgOpenBank: res.data.borg_open_bank,
            borgBankNum: res.data.borg_bank_num,
            corgName: res.data.corg_name,
            corgAddress: res.data.corg_address,
            corgContacts: res.data.corg_contacts,
            corgPhone: res.data.corg_phone,
            corgOpenBank: res.data.corg_open_bank,
            corgBankNum: res.data.corg_bank_num,
            payMoney: res.data.pay_money,
            lockMoney: res.data.lock_money,
            surplusMoney: res.data.surplus_money,
            fanben: res.data.fanben ? JSON.parse(res.data.fanben) : [],
            yingxiang: res.data.yingxiang ? JSON.parse(res.data.yingxiang) : [],
            xiangguanwenjian: res.data.xiangguanwenjian ? JSON.parse(res.data.xiangguanwenjian) : [],
          }
          if (this.ruleForm.money) this.ruleForm.moneyCN = digitUppercase(this.ruleForm.money)
        })
      await this.getYdList()

    },

    contractLogList() {
      this.$api.apiContent
        .contractLogList({
          mid: this.$store.state.userMid,
          contractId: this.$route.query.htid,
          display: 10000,
        }).then(res => {
        this.logList = res.data.data
      })
    },


    editItem(item) {
      this.setId = item.id
      this.setItem = item
      this.ydListState = true
    },
    delItem(id) {
      this.$api.apiContent
        .contractPayAppointmentDelete({
          mid: this.$store.state.userMid,
          contractId: this.$route.query.htid,
          id: id
        }).then(() => {
        this.getYdList()
      })
    },
    getYdList() {
      this.ydListState = false
      this.setId = 0
      this.setItem = null
      this.$api.apiContent
        .contractPayAppointmentList({
          mid: this.$store.state.userMid,
          contractId: this.$route.query.htid
        }).then(res => {
        this.ruleForm.paymentContract = res.data
      })
    },

    delFile(name, index) {
      this.ruleForm[name].splice(index, 1);
    },
    //  获取当前文件或文件夹的导航
    NowTab() {
      this.$api.apiContent
        .NowTab({
          mid: this.$store.state.userMid,
          FileId: this.$route.query.cid
        })
        .then(res => {
          this.KuName = res.data[0].name;
          this.navName = "";
          this.navStr = [];
          var data = res.data;
          for (var i = 0; i < data.length; i++) {
            if (data[i].name) {
              this.navStr.push(data[i])
              continue
            }
            this.navStr.push(
              {"name": data[i].label, "id": data[i].id}
            )
          }
        });
    },
    prev() {
      this.$router.go(-1);
      this.$store.state.upTree = true;
    },
  },
  filters: {
    payment_type(val) {
      return filesCN(Number(val), paymentType)
    }
  },
  watch: {
    'ruleForm.money'() {
      this.ruleForm.moneyCN = digitUppercase(this.ruleForm.money)
    }
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  .right-header {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    b {
      font-size: 18px;
      padding-right: 5px;
    }

    .crumbs {
      font-size: 18px;
      line-height: 30px;
    }

    .goBtn {
      display: block;
      height: 42px;
      line-height: 42px;
      width: 60px;
      text-align: center;
      border-radius: 6px;
      cursor: pointer;
      background: #0a2240;
      color: #ffffff;
    }
  }

  .mode-title {
    height: 40px;
    line-height: 40px;
    position: relative;
    padding-left: 20px;
    font-size: 18px;
    color: #0a2240;
    font-weight: bold;
    margin: 15px 0;

    &:before {
      position: absolute;
      top: 5px;
      left: 0;
      width: 5px;
      height: 30px;
      content: '';
      background: #fc7802;
    }
  }

  .other-box {
    width: 300px;
    border-left: 1px solid #f5f5f5;
    padding-left: 20px;
    min-height: 500px;

  }

  .el-select {
    width: 100%;
  }

  .el-input {
    width: 100%;
  }

  .file-item {
    margin-bottom: 10px;
    padding: 5px 0;
    border-bottom: 1px solid #f5f5f5;

    .file-item-name {
      width: 80%;

      a {
        font-size: 16px;
      }

    }

    .close-icon {
      font-size: 22px;
      color: #e4393c;
    }
  }
}
</style>
